<template>
  <template v-if="criteriaType === 'MULTISELECTRANGE'">
    <MultiSelectRange :name="props.name" />
  </template>
  <template v-else>
    <MultiSelectDefault :name="props.name" />
  </template>
</template>

<script setup>
import { useFilteringFacetsStore } from '~/stores/filteringFacets';
import MultiSelectRange from '~/components/FilteringFacets/Criteria/MultiSelectRange';
import MultiSelectDefault from '~/components/FilteringFacets/Criteria/MultiSelectDefault';

const filteringFacetsStore = useFilteringFacetsStore();
const props = defineProps({
  name: {
    type: String,
    default: 'Category',
  },
});

const criteriaType = computed(() => filteringFacetsStore.facetByName(props.name)?.facetType);
</script>
